import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "@nuxtjs/composition-api";

import { useAmplitude, useLinkService } from "@/composables";
import { useCreatorShop } from "@/store/creator-shop";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopProductTile',
  props: {
  title: { type: String, required: true },
  subtitle: { type: String, required: true },
  imageUrl: { type: String, required: true },
  href: { type: String, default: "" },
  to: { type: [String, Object], default: "" },
  width: { type: [String, Number], default: "100%" },
  height: { type: [String, Number], default: "100%" },
  aspect: { type: [String, Number], default: 1 },
  disabled: { type: Boolean, default: false },
  amplitudePayload: { type: Object as PropType<LtkProductProps>, required: true },
},
  setup(__props) {

const props = __props;



const amplitude = useAmplitude();
const linkService = useLinkService();

const onClick = () => {
  useCreatorShop().setReferringShopTab();
  amplitude?.sendExitEvent("/product-browser", props.amplitudePayload);
};

const imageOptimized = computed(() => {
  return linkService.getImageLink({
    url: props.imageUrl,
    width: `${props.width}`,
    height: `${props.width}`,
    crop: false,
  });
});

return { __sfc: true,props, amplitude, linkService, onClick, imageOptimized }
}

})